export default "__VITE_ASSET__DJex9JHv__"